var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIconMissionH2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g5kbxtiyna",
    d: "M0 65.74h63.556V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.556 29.945c0 16.537-14.228 29.944-31.778 29.944C14.228 59.889 0 46.482 0 29.945 0 13.407 14.228 0 31.778 0c17.55 0 31.778 13.407 31.778 29.945",
    fill: "#D7F4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.778 65.74c-8.967 0-17.368-3.335-23.652-9.392a1.344 1.344 0 1 1 1.865-1.936c5.78 5.572 13.519 8.641 21.787 8.641 8.248 0 15.97-3.054 21.746-8.6a1.344 1.344 0 1 1 1.861 1.938c-6.278 6.03-14.662 9.35-23.607 9.35",
    fill: "#3CCE3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.492 17.805H16.064a3.929 3.929 0 0 0-3.93 3.929V53.42c5.42 4.046 12.267 6.469 19.717 6.469 7.384 0 14.174-2.38 19.57-6.36V21.733a3.928 3.928 0 0 0-3.929-3.929",
    fill: "#3CCE3C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "urhihbgvvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g5kbxtiyna"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#urhihbgvvb)",
    d: "M30.14 32.389h3.274v-4.445H30.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.1 30.747 2.14 3.027c2.953-1.484 6.276-2.262 9.703-2.262 3.157 0 6.254.667 9.04 1.936l2.252-3.182c-3-2.464-7.041-3.856-11.292-3.856-4.53 0-8.796 1.571-11.842 4.337zm1.647 6.8c-.516 0-1.02-.242-1.338-.691l-3.404-4.816a1.638 1.638 0 0 1-.3-.944v-.927c0-.429.168-.842.47-1.149 3.682-3.74 9.065-5.885 14.768-5.885 5.582 0 10.89 2.067 14.564 5.67.314.308.49.73.49 1.169v.12c0 .34-.105.67-.3.945l-3.85 5.445a1.64 1.64 0 0 1-2.12.493c-2.631-1.434-5.669-2.191-8.784-2.191-3.361 0-6.595.875-9.355 2.528a1.635 1.635 0 0 1-.84.234z",
    fill: "#FFF",
    mask: "url(#urhihbgvvb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIconMissionH2);
export default __webpack_public_path__ + "static/media/ic-icon-mission-h-2.8be35d6ea51140628d15e7a0474d873e.svg";
export { ForwardRef as ReactComponent };